import {Fragment} from 'react';
import PropTypes from 'prop-types';
import {
	find as _find,
	map as _map,
	each as _each,
	flatten as _flatten,
} from 'lodash';
import {
	LayersControlGroup,
	LayersControlGroupContent,
	LayersControlGroupDescription,
	LayersControlGroupHeader,
	LayersControlGroupItem,
} from '../../components';
import Checkbox from '../../../../../atoms/Checkbox';
import WmsLayersLegend from './WmsLayersLegend';
import './style.scss';

const WmsLayersControls = ({
	groups,
	groupLayers,
	layers,
	availableLayers,
	setWmsLayers,
}) => {
	const handleWmsLayers = key => {
		setWmsLayers(getCurrentMapWmsLayers(key));
	};

	const getCurrentMapWmsLayers = key => {
		const wmsLayerKeys = _flatten(groups.map(group => group.layers));
		const wmsLayerKeysOrdered = wmsLayerKeys.slice().reverse();

		let l = [];
		_each(wmsLayerKeysOrdered, wmsLayerKey => {
			const wmsLayer = availableLayers[wmsLayerKey];
			if (wmsLayer) {
				const presentInCurrentMapLayers = _find(
					layers,
					layer => layer.key === wmsLayerKey
				);
				if (presentInCurrentMapLayers && wmsLayerKey !== key) {
					l.push(wmsLayer);
				} else if (!presentInCurrentMapLayers && wmsLayerKey === key) {
					l.push(wmsLayer);
				}
			}
		});

		return l;
	};

	return _map(groupLayers, key => {
		const active = _find(layers, layer => layer.key === key);
		const wmsLayer = availableLayers[key];

		if (wmsLayer) {
			return (
				<Fragment key={key}>
					<Checkbox
						onChange={() => handleWmsLayers(key)}
						checked={active}
						name={wmsLayer.name}
					/>
					<WmsLayersLegend layerKey={key} active={active} />
				</Fragment>
			);
		} else {
			return null;
		}
	});
};

WmsLayersControls.propTypes = {
	layers: PropTypes.array,
	availableLayers: PropTypes.object,
	setWmsLayers: PropTypes.func,
};

const RasterLayersControls = ({
	groups,
	layers,
	availableWmsLayers,
	setWmsLayers,
}) => {
	return groups.map((group, i) => (
		<LayersControlGroup key={i}>
			<LayersControlGroupHeader>{group?.name}</LayersControlGroupHeader>
			{group?.description ? (
				<LayersControlGroupDescription>
					{group?.description}
				</LayersControlGroupDescription>
			) : null}
			<LayersControlGroupContent>
				<LayersControlGroupItem>
					<WmsLayersControls
						groupLayers={group?.layers}
						groups={groups}
						layers={layers}
						availableLayers={availableWmsLayers}
						setWmsLayers={setWmsLayers}
					/>
				</LayersControlGroupItem>
			</LayersControlGroupContent>
		</LayersControlGroup>
	));
};

RasterLayersControls.propTypes = {
	availableWmsLayers: PropTypes.object,
	groups: PropTypes.array,
	layers: PropTypes.array,
	setWmsLayers: PropTypes.func,
};

export default RasterLayersControls;
